/** Copyright (c) 2019 <span className='trp-nowrap-nobold'>T. Rowe Price</span>. All rights reserved. */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import './QuotesResearch.scss';
import AAMFooterContainer from '../Footer/FooterUtil';
import { mapProductTypeToiiFooterBoolean } from 'state/account/AccountSelectors';
import { isMobile } from 'state/view/ViewSelectors';
import {legalReferenceNumbers} from "services/Content";
import LegalReferenceNumber from 'components/layouts/LegalReferenceNumber/LegalReferenceNumber';

const QuotesResearch = ({ footerProductTypes, isMobileApp }) => {
  return (
    <Fragment>
      <div className={'quotes-research'}>
        <iframe
          style={{flex:'auto', height:'2600px', overflow: 'visible', marginTop: '40px'}}
          id='quotes-research-iframe'
          src='https://trp.factsetdigitalsolutions.com/ext/fio/trowe-price-investment-services/markets/summary'
        />
        <div className={'quotes-research-user-agreement'}>
          <div className={'basic-layout-container'}>
            <h4 className={'quotes-research-user-agreement-header'}>
              Research & Analysis User Agreement
            </h4>
            <p className={'content-text'}>
              Your use of the information within the Research & Analysis section
              of the <span className="trp-nowrap-nobold">T. Rowe Price</span>{' '}
              website (the &quot;Site&quot;) constitutes your acceptance of this
              Research & Analysis User Agreement and FactSet Digital Solutions
              LLC’s{' '}
              <a
                className="terms-link"
                href="https://www.factset.com/legal"
                target="_blank"
                rel="noreferrer">
                Terms of Use
              </a>{' '}
              (collectively &quot;User Agreement&quot;). If you do not agree
              with the terms of this User Agreement, or if you cannot remain in
              compliance with such terms, you may not access or use the Site.
            </p>
            <p className={'content-text'}>
              The Information is provided for informational and/or educational
              purposes only, and may only be used, downloaded and printed for
              personal, non-commercial use. The Information may not be used for
              any unlawful or unauthorized purpose. It is not intended to
              provide tax, legal, or investment advice, and should not be
              construed as an offer to buy or sell, a solicitation of an offer
              to buy, or a recommendation for any security by{' '}
              <span className="trp-nowrap-nobold">T. Rowe Price</span> or any
              third-party provider.{' '}
              <span className="trp-nowrap-nobold">T. Rowe Price</span> does not
              guarantee the suitability or potential value of any particular
              investment or information source. You acknowledge that your
              requests for information are unsolicited and shall neither
              constitute, nor be considered, investment advice by{' '}
              <span className="trp-nowrap-nobold">T. Rowe Price</span>. You
              understand that you alone are responsible for determining whether
              any investment, security, or strategy is appropriate or suitable
              for you and that neither{' '}
              <span className="trp-nowrap-nobold">T. Rowe Price</span> nor any
              third-party provider has made any determination that any
              recommendation, investment, or strategy in any Information is
              suitable or appropriate for you based on your investment
              objectives and financial situation.
            </p>
            <p className={'content-text'}>
              Securities mentioned in any Information reflect independent
              analysts&apos; opinions and are not recommendations of T. Rowe
              Price.
            </p>
            <p className={'content-text'}>
              <span className="trp-nowrap-nobold">T. Rowe Price</span> has not
              reviewed this Information. The accuracy, completeness, timeliness,
              and correct sequencing of the Information are not guaranteed by{' '}
              <span className="trp-nowrap-nobold">T. Rowe Price</span>.{' '}
              <span className="trp-nowrap-nobold">T. Rowe Price</span>
              does not make any warranty, express or implied, as to the results
              to be obtained by you or any other person from the use of the
              Information. Any reliance on the Information is at your own risk.
              <span className="trp-nowrap-nobold">T. Rowe Price</span> will not
              be liable for any losses incurred.
            </p>
          </div>
        </div>
      </div>
      <LegalReferenceNumber
        providedLegalNumber={legalReferenceNumbers.QUOTES_RESEARCH_LRN}
      />
      <AAMFooterContainer
        isMobileParam={isMobileApp}
        footerProductTypes={footerProductTypes}
        appLoaded={true}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  footerProductTypes: mapProductTypeToiiFooterBoolean(state),
  isMobileApp: isMobile(state)
});

export default connect(mapStateToProps)(QuotesResearch);
